import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kh-labeled-field',
  styleUrls: ['./labeled-field.component.less'],
  templateUrl: './labeled-field.component.html',
  standalone: false
})
export class LabeledFieldComponent {
  @Input() public controlValue!: FormControl;
  @Input() public placeholder = '';
}
